import {
    GET_SESSION_BY_ID_SUCCESS,
    GET_SESSION_CORRECTIONS_SUCCESS,
    GET_SESSIONS_SUCCESS,
    SAVE_SESSION_TARGET_OPTION_SUCCESS,
    GET_MANUAL_SESSION_APPTS_SUCCESS,
    GET_MANUAL_SESSION_SUCCESS,
    RESET_MANUAL_SESSION,
    GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS,
} from './session.types';

const initialState = {
    sessionList: [],
    sessionById: null,
    sessionCorrections: [],
    manualSessionAppts: [],
    manualSession: null,
    manualMaintenanceChecks: [],
};

const mutateSession = (state, payload) => {
    const { goalId, targetId } = payload;

    return {
        ...state.sessionById,
        goals: state.sessionById.goals.map((g) => {
            return g?.goal?.id === goalId
                ? {
                      ...g,
                      goal: {
                          ...g.goal,
                          targets: g.goal.targets.map((t) => (t.id === targetId ? { ...t, tSummary: payload } : t)),
                      },
                  }
                : g;
        }),
    };
};

export const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Goals */
        case GET_SESSIONS_SUCCESS:
            return {
                ...state,
                sessionList: action.payload,
            };

        case GET_SESSION_BY_ID_SUCCESS:
            return {
                ...state,
                sessionById: action.payload,
            };

        case SAVE_SESSION_TARGET_OPTION_SUCCESS:
            return {
                ...state,
                sessionById: mutateSession(state, action.payload),
            };

        case GET_SESSION_CORRECTIONS_SUCCESS:
            return {
                ...state,
                sessionCorrections: action.payload,
            };

        case GET_MANUAL_SESSION_APPTS_SUCCESS:
            return {
                ...state,
                manualSessionAppts: action.payload,
            };

        case GET_MANUAL_SESSION_SUCCESS:
            return {
                ...state,
                manualSession: action.payload,
            };

        case GET_MANUAL_MAINTENANCE_CHECKS_SUCCESS:
            return {
                ...state,
                manualMaintenanceChecks: action.payload,
            };

        case RESET_MANUAL_SESSION:
            return {
                ...state,
                manualSessionAppts: [],
                manualSession: null,
                manualMaintenanceChecks: [],
            };
        /** End */

        default:
            return state;
    }
};
